import { FC } from 'lib/component-utils'
import { useUserContext } from 'lib/context'
import { storage } from 'lib/local-storage'
import { useEffect } from 'react'
import { useState } from 'react'
import Card from 'components/base/Card'
import { XIcon } from '@heroicons/react/outline'
import Button from 'components/base/Button'
import { useIntl } from 'lib/intl-utils'

const SurveyNotifier: FC = () => {
  const ctx = useUserContext()
  const { t } = useIntl()
  const [show, setShow] = useState(false)

  // useEffect(() => {
  //   setShow(['sellmonitor'].includes(ctx.theme.hostType) && !storage.get('surveyNotifier:closed'))
  // }, [])

  if (!show) return null

  return (
    <Card className="bg-white px-5 py-3 !shadow-xl relative">
      <button
        className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
        onClick={() => {
          storage.set('surveyNotifier:closed', true)
          setShow(false)
        }}
      >
        <XIcon className="size-4" />
      </button>
      <div className="flex items-start gap-2">
        <div>
          <h3 className="text-sm font-medium">{t`survey.title`}</h3>
          <p className="text-sm text-gray-600">
            {t`survey.description`}
          </p>
        </div>
      </div>
      <Button
        as="a"
        href="https://forms.gle/ZdWq2LAtoNN9vxRs5"
        target="_blank"
        theme="primary"
        className="mt-4"
        onClick={() => {
          storage.set('surveyNotifier:closed', true)
          setShow(false)
        }}
      >
        {t`survey.action`}
      </Button>
    </Card>
  )
}

export default SurveyNotifier
